const caCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Nom del fitxer...",
    description: "Placeholder for file name input",
  },
};

export default caCreateFile;
